import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate } from '@tanstack/react-router';
import { useRef, useState, type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { SETTINGS_BASE_PATH } from '../../features/settings/routes';
import { useLogoutMutation } from '../../lib/auth';

export function ProfileMenu(): ReactElement {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const anchorRef = useRef<HTMLButtonElement>(null);
    const logout = useLogoutMutation();
    const navigate = useNavigate();

    const handleSettings = (): void => {
        setOpen(false);
        void navigate({ to: SETTINGS_BASE_PATH });
    };

    const handleLogout = (): void => {
        setOpen(false);
        logout.mutate();
    };

    return (
        <>
            <IconButton
                ref={anchorRef}
                onClick={() => setOpen(true)}
                sx={{ p: 0, opacity: 0.9 }}
                aria-label={t('PROFILE.MENU_ARIA')}
                aria-expanded={open}
                aria-haspopup="true">
                <Avatar sx={{ width: 40, height: 40 }}>
                    <PersonIcon />
                </Avatar>
            </IconButton>

            <Menu
                anchorEl={anchorRef.current}
                open={open}
                onClose={() => setOpen(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                slotProps={{ paper: { elevation: 8, sx: { mt: 0.5 } } }}>
                <MenuItem onClick={handleSettings}>
                    <ListItemIcon>
                        <SettingsIcon fontSize="small" />
                    </ListItemIcon>
                    {t('PROFILE.SETTINGS')}
                </MenuItem>
                <MenuItem onClick={handleLogout} disabled={logout.isPending}>
                    <ListItemIcon>
                        <LogoutIcon fontSize="small" />
                    </ListItemIcon>
                    {t('PROFILE.LOG_OUT')}
                </MenuItem>
            </Menu>
        </>
    );
}
